import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const Loader = ({ value = 0 }) => {
  const ref = useRef(null);

  const radius = 70;
  const border = 100;
  const origin = 1;
  const start = 0;
  const angle = Math.PI / 2;
  const min = 0;
  const max = 100;

  const diameter = 2 * radius;
  const halfBorder = border / 2;
  const length = (Math.PI + 2 * angle) * radius;

  const percent = value < start ? (Math.abs(value - start) / Math.abs(min - start)) * (1 - origin) : (Math.abs(value - start) / Math.abs(max - start)) * origin;

  const strokeDashoffset = value < start ? length * (percent + origin) : length * origin;

  const strokeDasharray = `${length * percent} ${length * (1 - percent)}`;
  const strokeWidth = border;

  const cosine = Math.cos(angle);
  const sine = Math.sin(angle);
  const x = radius * (1 - cosine);
  const y = radius * (1 + sine);
  const shouldUse2Arcs = angle !== 0 && angle % (Math.PI / 2) === 0;
  const d = `M ${x} ${y}
      ${shouldUse2Arcs ? `A ${radius} ${radius} 0 1 1 ${diameter - x} 0` : ''}
      A ${radius} ${radius} 0 ${angle < 0 ? 0 : 1} 1 ${diameter - x} ${y}`;

  return (
    <svg ref={ref} className="files-loader__svg" viewBox={`${-halfBorder} ${-halfBorder} ${diameter + border} ${diameter + border}`}>
      <circle className="files-loader__svg-circle" r={radius - halfBorder} cx={radius} cy={radius} />
      <path className="files-loader__svg-bar" style={{ strokeWidth }} d={d} />
      <path
        className="files-loader__svg-progress"
        style={{
          strokeWidth,
          strokeDashoffset,
          strokeDasharray,
        }}
        d={d}
      />
    </svg>
  );
};

Loader.propTypes = {
  value: PropTypes.number,
};

export default Loader;
